export default __webpack_public_path__ + "static/media/logo_text_white.b7b43311.png";